function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.7454 99.1575C90.6518 87.4609 99.7391 59.4097 88.0426 36.5033C76.346 13.5969 48.2947 4.50952 25.3883 16.2061C2.4819 27.9027 -6.60545 55.954 5.09114 78.8604C16.7877 101.767 44.839 110.854 67.7454 99.1575Z",
  fill: "#E5E5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3603 35.93L48.4303 25.75C47.9246 25.2769 47.2579 25.0137 46.5653 25.0137C45.8727 25.0137 45.2061 25.2769 44.7003 25.75L33.8203 35.93H59.3603Z",
  fill: "#808080"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5703 35.9299H23.5703V55.5899L38.5703 67.0199H54.5703L69.5703 55.5899V35.9299Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59 52H35C34.7348 52 34.4804 51.9473 34.2929 51.8536C34.1054 51.7598 34 51.6326 34 51.5C34 51.3674 34.1054 51.2402 34.2929 51.1464C34.4804 51.0527 34.7348 51 35 51H59C59.2652 51 59.5196 51.0527 59.7071 51.1464C59.8946 51.2402 60 51.3674 60 51.5C60 51.6326 59.8946 51.7598 59.7071 51.8536C59.5196 51.9473 59.2652 52 59 52Z",
  fill: "#808080"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M59 57H35C34.7348 57 34.4804 56.9473 34.2929 56.8536C34.1054 56.7598 34 56.6326 34 56.5C34 56.3674 34.1054 56.2402 34.2929 56.1464C34.4804 56.0527 34.7348 56 35 56H59C59.2652 56 59.5196 56.0527 59.7071 56.1464C59.8946 56.2402 60 56.3674 60 56.5C60 56.6326 59.8946 56.7598 59.7071 56.8536C59.5196 56.9473 59.2652 57 59 57Z",
  fill: "#808080"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M59 62H35C34.7348 62 34.4804 61.9473 34.2929 61.8536C34.1054 61.7598 34 61.6326 34 61.5C34 61.3674 34.1054 61.2402 34.2929 61.1464C34.4804 61.0527 34.7348 61 35 61H59C59.2652 61 59.5196 61.0527 59.7071 61.1464C59.8946 61.2402 60 61.3674 60 61.5C60 61.6326 59.8946 61.7598 59.7071 61.8536C59.5196 61.9473 59.2652 62 59 62Z",
  fill: "#808080"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6703 55.6699L23.5703 55.5899V45.4299L17.5703 51.0199L23.6703 55.6699Z",
  fill: "#808080"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5704 45.4299V55.5899L69.3604 55.7499L75.5704 51.0199L69.5704 45.4299Z",
  fill: "#808080"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5703 83.02H17.7003H75.1103H75.4403H75.5703L54.5703 67.02H38.5703L17.5703 83.02Z",
  fill: "#DADADA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5703 83.02V51.02L38.5703 67.02L17.5703 83.02Z",
  fill: "#CCCCCC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M75.5703 83.02V51.02L54.5703 67.02L75.5703 83.02Z",
  fill: "#CCCCCC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M102.59 18.2C103.3 17.66 117.24 6.62 117.24 6.62L111.12 24.16L102.59 18.2Z",
  fill: "#CCCCCC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M89.2002 14.71C89.2002 14.71 96.5802 16.51 96.7402 16.4C96.9002 16.29 117.24 6.62 117.24 6.62L89.2002 14.71Z",
  fill: "#CCCCCC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M96.75 16.4L98.55 24.43L102.59 18.2L117.24 6.62L96.75 16.4Z",
  fill: "#808080"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M98.5503 24.43L103.98 19.18L102.59 18.2L98.5503 24.43Z",
  fill: "#595959"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8101 31.32C73.1801 30.75 75.3701 30.56 77.9401 33.04C82.2801 37.23 77.9401 46.82 85.1901 46.67C90.3601 46.56 90.8801 35.93 87.8801 35.97C84.8801 36.01 86.7201 41.26 89.8801 41.28C99.6801 41.34 95.5101 31.54 95.5101 31.54C95.5101 31.54 94.8201 27.72 96.0101 25.84",
  stroke: "#506B7C",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRegistered = function SvgRegistered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 118,
    height: 105,
    viewBox: "0 0 118 105",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRegistered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registered.3c5803fd.svg";
export { ForwardRef as ReactComponent };